import { Alert, Box, Button, Chip, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { rutas } from "../../rutas/rutas";
import { setInformacion } from "../../storage/slices/usuarios";
import utc from "dayjs/plugin/utc";
import fondo from "../../Web Mundo/fondo.mp3";
import ReactHowler from "react-howler";
import { getCookie } from "../../utils/getCookie";
import axios from "axios";

dayjs.extend(utc);

export const Cronometro = ({ time, timeServer, tipo = "normal" }) => {
  const dispatch = useDispatch();

  const date1 = dayjs(time).utc();
  const date2 = dayjs(new Date()).utc();

  const [misionTiempo, setMisionTiempo] = useState(date1.diff(date2, "seconds"));
  const [tiempo, setTiempo] = useState("00:00:00");

  const [reward, setReward] = useState("");
  const [rewardInfo, setRewardInfo] = useState(null);
  const [petBenefit, setPetBenefit] = useState(null);

  const [usuario, setUsuario] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [finalizo, setFinalizo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState("");

  const secondsToString = (seconds) => {
    const safeSeconds = Math.max(0, Number(seconds || 0));

    let hour = Math.floor(safeSeconds / 3600);
    hour = hour < 10 ? "0" + hour : hour;

    let minute = Math.floor((safeSeconds / 60) % 60);
    minute = minute < 10 ? "0" + minute : minute;

    let second = safeSeconds % 60;
    second = second < 10 ? "0" + second : second;

    return hour + ":" + minute + ":" + second;
  };

  const buildRewardDisplay = (data) => {
    if (!data) return "";

    if (data.reward) return data.reward;

    const info = data.rewardInfo;

    if (!info) return "";

    if (info.finalReward !== undefined) {
      if (Number(info.bonusReward || 0) > 0) {
        return `${info.finalReward} - HUESOS (${info.baseReward} base + ${info.bonusReward} pet bonus)`;
      }

      return `${info.finalReward} - HUESOS`;
    }

    if (info.finalEnergyReward !== undefined) {
      if (Number(info.bonusEnergy || 0) > 0) {
        return `${info.finalEnergyReward} - Energy (${info.baseEnergyReward} base + ${info.bonusEnergy} pet bonus)`;
      }

      return `${info.finalEnergyReward} - Energy`;
    }

    return "";
  };

  const collectMission = async () => {
    if (finalizo || loading) return;

    if (misionTiempo > 0 && tiempo !== "00:00:00") {
      setErrorText("Mission is not completed yet.");
      return;
    }

    try {
      setLoading(true);
      setErrorText("");

      const tokenJWT = getCookie("token");

      const { data } = await axios({
        method: "post",
        url: rutas.finalizar,
        headers: {
          token: tokenJWT,
          "Content-Type": "application/json",
        },
        data: { tipo },
      });

      if (data?.usuario) {
        setUsuario(data.usuario);
        dispatch(setInformacion(data.usuario));
      }

      setReward(buildRewardDisplay(data));
      setRewardInfo(data?.rewardInfo || null);
      setPetBenefit(data?.petBenefit || null);

      setPlaying(true);
      setTimeout(() => setPlaying(false), 1500);

      setFinalizo(true);
    } catch (error) {
      setErrorText(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Could not collect mission reward."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTiempo(secondsToString(misionTiempo));
  }, []);

  useEffect(() => {
    if (misionTiempo > 0) {
      const intervalo = setInterval(() => {
        const nowUtc = dayjs(new Date()).utc();
        const secondsLeft = date1.diff(nowUtc, "seconds");
        const timeActual = secondsToString(secondsLeft);

        document.title =
          timeActual.substring(0, 3) === "00:"
            ? timeActual.substring(3, timeActual.length)
            : timeActual;

        setTiempo(timeActual);
        setMisionTiempo(Math.max(0, secondsLeft));
      }, 1000);

      return () => clearInterval(intervalo);
    }

    setTiempo("00:00:00");
  }, [misionTiempo, time]);

  const petBonusActive = Boolean(petBenefit?.active);
  const hasMiniBoneBonus = Number(rewardInfo?.bonusReward || 0) > 0;
  const hasEnergyBonus = Number(rewardInfo?.bonusEnergy || 0) > 0;

  return (
    <>
      {misionTiempo > 0 ? (
        <Typography sx={{ textAlign: "center" }}>Finish - {tiempo}</Typography>
      ) : (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          {!finalizo ? (
            <>
              <Typography sx={{ textAlign: "center", display: "inline", mr: 1 }}>
                Mission completed
              </Typography>

              <Button
                variant="contained"
                onClick={collectMission}
                disabled={loading}
                color={tipo === "especial" ? "warning" : "primary"}
              >
                {loading ? "Collecting..." : "Collect"}
              </Button>
            </>
          ) : (
            <>
              <Stack spacing={0.6} sx={{ textAlign: "center" }}>
                <Typography sx={{ fontWeight: 800, color: "white" }}>
                  {reward}
                </Typography>

                {petBenefit && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 0.6,
                      flexWrap: "wrap",
                    }}
                  >
                    <Chip
                      size="small"
                      label={
                        petBonusActive
                          ? `Puppy bonus active | Level ${petBenefit.level}`
                          : "Puppy bonus inactive"
                      }
                      sx={{
                        fontWeight: 800,
                        color: petBonusActive ? "black" : "white",
                        backgroundColor: petBonusActive ? "#00e676" : "#777",
                      }}
                    />

                    {hasMiniBoneBonus && (
                      <Chip
                        size="small"
                        label={`+${rewardInfo?.miniHuesoBonusPercent}% Mini-Bone`}
                        sx={{
                          fontWeight: 800,
                          color: "black",
                          backgroundColor: "#ffb300",
                        }}
                      />
                    )}

                    {hasEnergyBonus && (
                      <Chip
                        size="small"
                        label={`+${rewardInfo?.energyBonusPercent}% Energy`}
                        sx={{
                          fontWeight: 800,
                          color: "black",
                          backgroundColor: "#29b6f6",
                        }}
                      />
                    )}
                  </Box>
                )}
              </Stack>

              <Button
                variant="contained"
                onClick={() => {
                  if (usuario) dispatch(setInformacion(usuario));
                }}
              >
                Close
              </Button>
            </>
          )}

          {errorText && (
            <Alert severity="error" sx={{ width: "100%", mt: 1 }}>
              {errorText}
            </Alert>
          )}
        </Box>
      )}

      {playing && (
        <ReactHowler loop={true} playing={playing} volume={0.2} src={fondo} />
      )}
    </>
  );
};